import React, { useState, useEffect, useContext } from 'react';
import { useFormContext } from '../utils/FormContext'; 
import { FormProvider } from '../utils/FormContext';
import { StepProvider } from '../utils/StepContext';
import StepRenderer from '../components/StepRenderer';
import { useAuth } from '../utils/AuthContext/AuthContext';
import { useParams, useLocation } from 'react-router-dom';
import { AddressValueContext, AddressValueProvider } from '../utils/AddressContext';
import config from '../utils/config'


const ContractForm = () => {
    const { formId } = useParams();
    const { token } = useAuth();
    const { setFormData } = useFormContext(); 
    const [searchAddress, setSearchAddress] = useState('');
    const [nameCardAddress, setNameCardAddress] = useState('');
    const location = useLocation(); 
    const initialStep = location.state?.step || 0; 
    

    useEffect(() => {
        async function fetchData(formId) {
            if (!formId || !token) {
                // If formId is undefined, don't make the fetch request
                console.log("Error Fetching, no token or formId found")
                return;
            }
    
            try {
                // const response = await fetch(`http://localhost:5000/api/formdata/${formId}`, {
                    const response = await fetch(`${config.apiBaseUrl}/formdata/${formId}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setFormData(data); 
                // console.log("formData after fetch:", data);
                if (data.data?.address) {
                    const addressString = Object.values(data.data.address).join(', ');
                    setSearchAddress(addressString);
                    // console.log("Address Value in contractform:", Object.values(data.data.address).join(', '));
                }
                if (data.data?.buyer1HomeAddress) {
                    const buyer1AddressString = Object.values(data.data.buyer1HomeAddress).join(', ');
                    setNameCardAddress(buyer1AddressString);
                    // console.log("Name Card Address Value in contractform:", Object.values(data.data.buyer1HomeAddress).join(', '));
                }
            } catch (error) {
                console.error("Error fetching contracts:", error);
            }
        }
        fetchData(formId);
    }, [formId, token]); 

    return (
        <AddressValueContext.Provider value={{ searchAddress, setSearchAddress, nameCardAddress, setNameCardAddress }}>
            
                <FormProvider>
                    <StepProvider initialStep={initialStep}>
                        <StepRenderer />
                    </StepProvider>
                </FormProvider>
            
        </AddressValueContext.Provider>
    );
};

export default ContractForm;